import { render } from "./NotePage.vue?vue&type=template&id=bd975868&scoped=true"
import script from "./NotePage.vue?vue&type=script&lang=js"
export * from "./NotePage.vue?vue&type=script&lang=js"

import "./NotePage.vue?vue&type=style&index=0&id=bd975868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd975868"]])

export default __exports__